import { useController } from "react-hook-form";
import { BrandKitChoiceRow } from "../../../brand-kit/components/choice-row";

import type { BrandKitLogo } from "../../../brand-kit/server/brand-kit-service";
import type { EmailDesignSchema } from "../../../email-design/types/email-design-type";
import type { FC } from "react";

export const CeLogoSelect: FC<{ logos: BrandKitLogo[] }> = ({ logos }) => {
  const { field: srcField } = useController<EmailDesignSchema, "header.logo.src">({
    name: "header.logo.src",
  });

  return (
    <BrandKitChoiceRow
      existing={logos}
      setSelected={(id) => {
        srcField.onChange(logos.find((logo) => logo.id === id)?.src ?? null);
      }}
      type="logo"
      selected={logos.find((logo) => logo.src === srcField.value)}
      showDefaultIndicator={false}
    />
  );
};
